import baseApplicationItem from './baseApplicationItem'
import {merge} from 'lodash'
import Vue from 'vue'

var module = {
  endpoint: 'category',
  getNew: {
    deleted: false,
    name: null,
    catalogs: [],
    parent: null
  },
  tableInfo: {
    tableFields: [
      {
        name: '__component:badge-deleted-column',
        title: '',
        dataClass: 'text-center'
      },
      {
        name: '__checkbox',
        title: '',
        class: 'primary'
      },
      {
        name: 'id',
        title: 'id',
        sortField: 'id'
      },
      {
        name: 'name',
        title: 'nome',
        sortField: 'name'
      },
      {
        name: 'description',
        title: 'descrizione',
        sortField: 'description'
      },
      {
        name: 'parent.name',
        title: 'categoria genitore',
        sortField: 'parent.name'
      },
      {
        name: '__component:actions-column',
        title: '',
        dataClass: 'text-center'
      }
    ],
    sortFunctions: {
    }
  },
  async getParentsCategory () {
    let url = `category/parents`
    let results = (await Vue.http.get(url)).body
    return results
  },
  async getSubcategories (categoryId) {
    let url = `subcategory/${categoryId}`
    let results = (await Vue.http.get(url)).body
    return results
  },
}

export default merge(module, baseApplicationItem)



// WEBPACK FOOTER //
// ./src/application/categories.js